import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../core'
import * as fsFunctions from '../../fs-functions'

export const RESOURCE = {
  payload: {
    description:
      'A functional category used in institutional financial reporting.',
    dimension: fsFunctions.RESOURCE.payload,
    level: 0,
    name: 'Financial Statement Function',
    partialId: PartialId.Standard.create('func'),
  },
  type: core.quiver.Resource.Type.DmsEntity,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEntity>

export const MODEL_ID = core.dms.models.Entity.Id.from({
  context: core.dms.models.Entity.Id.Context.from(RESOURCE.payload.dimension),
  partialId: RESOURCE.payload.partialId,
})
